import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Label } from "~/components-shared";
import styled from "styled-components";
import InputTextControl from "~/components/InputTextControl";
import lists from "~/lib/lists";
const Fieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const NodeForm = _ref => {
  let {
    control,
    watch,
    setValue
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Fieldset, null, /*#__PURE__*/React.createElement(InputTextControl, {
    name: "name",
    placeholder: t("NodeForm.namePlaceholder"),
    label: t("NodeForm.name"),
    control: control,
    s: {
      mb: 4
    },
    required: true
  }), /*#__PURE__*/React.createElement(Label, {
    s: {
      mb: 2
    },
    required: true
  }, t("NodeForm.subdomain")), /*#__PURE__*/React.createElement(Box, {
    gap: 2,
    s: {
      mb: 4
    }
  }, Object.keys(lists.visualize.nodeSubdomains.names).map(key => /*#__PURE__*/React.createElement(Button, {
    onClick: () => setValue("subdomain", key),
    fontSize: 3.5,
    color: watch("subdomain") === key ? "translucentPrimary" : "translucent",
    s: {
      px: 3,
      py: 1
    }
  }, lists.visualize.nodeSubdomains.names[key]))), /*#__PURE__*/React.createElement(InputTextControl, {
    name: "keywords",
    placeholder: t("NodeForm.keywordPlaceholder"),
    label: t("NodeForm.keywords"),
    control: control,
    s: {
      mb: 4
    },
    required: true
  }));
};
export default NodeForm;